<template>
  <div class="dashboard-track">
    <div class="summary" v-if="showSummary">
      <transition-group name="fade-slide-bottom" tag="div">          
        <template v-for="step in summarySequence">
          <div
            v-if="step.type === 'tracker' && displayedSteps.includes(step.slug)"
            :key="step.slug"
            class="stat-tracker bounce-in"
          >
            <UserTrack :size="120" :progress="progress" xx:focus="getDialFocus" />
            <span class="message" v-html="getDialReckoner"></span>
          </div>

          <div
            v-if="step.type === 'border' && displayedSteps.includes(step.slug)"
            :key="`border-${step.slug}`"
            class="animated-border--legacy"
          ></div>

          <div
            v-else-if="step.type === 'stat' && displayedSteps.includes(step.slug)"
            :key="`stat-${step.slug}`"
            class="summary-item"
            :class="{'locked' : !step.unlocked }"
          >
            <transition-group name="fade-slide-right" tag="div" class="item-group">
              <div
                :key="`${step.slug}-icon`"
                :class="`${step.slug}-tone icon`"
                class="icon-text bounce-in"
              >
                <base-svg :svg="step.icon" width="20px" />
                <span>{{ getLabel(step.slug) }}</span>
              </div>
              <span
                :key="`${step.slug}-more`"
                class="more bounce-in"
              >
                {{ getReckoner(step.slug) }}
                <svg v-if="!step.unlocked" width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9141 4.85254C10.9139 3.00821 9.39249 1.5 7.5 1.5C5.60764 1.5 4.08706 3.00808 4.08691 4.85254V6.90039H10.9141V4.85254ZM1.5 16.5H13.5V7.90039H1.5V16.5ZM7 13V11.4004C7 11.1242 7.22386 10.9004 7.5 10.9004C7.77614 10.9004 8 11.1242 8 11.4004V13C8 13.2761 7.77614 13.5 7.5 13.5C7.22386 13.5 7 13.2761 7 13ZM11.9141 6.90039H14C14.2761 6.90039 14.5 7.12425 14.5 7.40039V17C14.5 17.2761 14.2761 17.5 14 17.5H1C0.723858 17.5 0.5 17.2761 0.5 17V7.40039C0.5 7.12425 0.723858 6.90039 1 6.90039H3.08691V4.85254C3.08706 2.44124 5.07003 0.5 7.5 0.5C9.92983 0.5 11.9139 2.4411 11.9141 4.85254V6.90039Z" fill="#14B31F"/>
                </svg>
              </span>
            </transition-group>
          </div>
        </template>
      </transition-group>
    </div>

    <transition name="fade-slide-right">
      <div v-show="showLocked" class="track-locked stat-tracker bounce-in">
        <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9141 4.85254C10.9139 3.00821 9.39249 1.5 7.5 1.5C5.60764 1.5 4.08706 3.00808 4.08691 4.85254V6.90039H10.9141V4.85254ZM1.5 16.5H13.5V7.90039H1.5V16.5ZM7 13V11.4004C7 11.1242 7.22386 10.9004 7.5 10.9004C7.77614 10.9004 8 11.1242 8 11.4004V13C8 13.2761 7.77614 13.5 7.5 13.5C7.22386 13.5 7 13.2761 7 13ZM11.9141 6.90039H14C14.2761 6.90039 14.5 7.12425 14.5 7.40039V17C14.5 17.2761 14.2761 17.5 14 17.5H1C0.723858 17.5 0.5 17.2761 0.5 17V7.40039C0.5 7.12425 0.723858 6.90039 1 6.90039H3.08691V4.85254C3.08706 2.44124 5.07003 0.5 7.5 0.5C9.92983 0.5 11.9139 2.4411 11.9141 4.85254V6.90039Z" fill="#14B31F"/>
        </svg>
        <h3>We'll get to this…</h3>
        <p>This track's just waiting in the wings while you focus like a pro. After 3 days of reading, it'll be ready to unlock.</p>
      </div>
    </transition>

    <transition name="fade-slide-right" v-if="showSummary">
      <div v-show="showHistory && summary.length > 0" class="history stat-tracker bounce-in">
        <div class="row" v-for="item in summary" :key="item.code">
          <div class="summary-image" :class="{'placeholder' : !item.image || item.image === ''}">
            <img v-if="getImage(item)" :src="getImage(item)" :alt="item.name" />
          </div>
          <span>{{ item.name }}</span>
          <span></span>
        </div>
      </div>
    </transition>

    <!-- <transition name="fade-slide-right">          
      <div v-if="showReadMore" class="read-more stat-tracker bounce-in">
        <span><span class="bold">Would you like to know more?</span><br/>Read the full story. Explore our sources.</span>
        <button @click="$emit('readMore')">Go deeper</button>
      </div>
    </transition> -->

    <transition name="fade-slide-right">          
      <div v-if="showPrevious" class="previous stat-tracker bounce-in">
        <div v-for="(day, key) in dialHistoryWeek" :key="key" class="stack">
          <UserTrack :size="40" :hideProfile="true" :progress="day" />
          <span>{{ key }}</span>
        </div>
      </div>
    </transition>

    <Lottie ref="lottie" animation="confetti-jump" />
  </div>
</template>

<script>
  import UserTrack from '@/components/v5/elements/UserTrack.vue';
  import Lottie from '@/components/v5/Lottie.vue';

  export default {
    data() {
      return {
        showHistory: false,
        showLocked: false,
        showReadMore: false,
        showPrevious: false,
        summarySequence: [],
        displayedSteps: [],
        progress: {
          time: 0,
          topics: 0,
          locales: 0
        },
        timing: {
          steps: 150, // master timing step (speeds/slows everthing)
        },
      }
    },

    props: {
      focus: {
        type: String,
      },

      readMore: {
        type: Boolean,
        default: false,
      },

      xp: {
        type: Number,
        default: null,
      },
    },

    components: {
      UserTrack,
      Lottie
    },

    mounted() {
      this.summarySequence = [];
      this.summarySequence.unshift({ type: 'tracker', slug: 'tracker' });
      if (this.xp) {
        this.summarySequence.push({ type: 'stat', unlocked: true , ...{
          slug: 'xp',
          icon: 'sparkles'
        } });
        this.summarySequence.push({ type: 'border', slug: `border-xp` });
      }
      this.summaryItems.forEach((item) => {
        this.summarySequence.push({ type: 'border', slug: `border-${item.slug}` });
        this.summarySequence.push({ type: 'stat', unlocked: this.isUnlocked(item.slug) , ...item });
      });
      this.summarySequence.push({ type: 'border', slug: `border-last` });
    
      // if (this.showReadMore) {
      //   this.summarySequence.push({ type: 'read-more', slug: 'read-more' });
      // }

      setTimeout(() => {
        this.animateSummary();
      }, this.timing.steps * 1);
    },

    computed: {
      dial() {
        return this.$store.getters.getLibraryItem('dial');
      },

      dialHistory() {
        return this.$store.getters.getLibraryItem('dial_history')?.history || [];
      },

      dialHistoryWeek() {
        return this.dialHistory.slice(0, 7);
      },

      getDialTracks() {
        return this.$userEngine.dialTracks;
      },
  
      getDialFocus() {
        return this.$userEngine.dialFocus;
      },

      getDialUnlocked() {
        return this.$userEngine.dialUnlocked;
      },

      getDialDiff() {
        return this.$userEngine.dialDiff;
      },

      getDialReckoner() {
        return this.$userEngine.getDialReckoner;
      },

      showSummary() {
        return this.dial?.rings || false;
      },

      summary() {
        return Object.values(this.dial.rings?.[this.focus]?.detail || {})
          .sort((a,b) => {
            return a.score > b.score ? -1 : 1;
          })
          .slice(0, 12);
      },

      summaryItems() {
        const tracks = this.$userEngine.dialTracks || {};

        if (!this.focus) {
          return tracks;
        }

        const item = Object.values(tracks).find(track => track.slug === this.focus);
        return item ? [item] : [];
      }
    },

    methods: {
      getImage (item) {
        if (this.focus == 'locales') {
          let sLocale = item.code.toLowerCase();
          return `https://nourished.news/r/i/icons/country_flags/2020/png-iso/${sLocale}.png`;
        }
        return (item.image && item.image !== '') ? item.image : null;
      },

      getLabel (slug) {
        if (slug === 'xp') {
          return `+${this.xp} XP`
        }
        return this.$userEngine.dialTrackLabel(slug);
      },

      getReckoner (slug) {
        if (slug === 'xp') {
          return 'XP Achieved'
        }
        return this.$userEngine.dialTrackReckoner(slug);
      },

      isUnlocked (slug) {
        return this.$userEngine.dialTrackUnlocked(slug);
      },

      animateSummary() {
        this.displayedSteps = [];

        const promises = this.summarySequence.map((step, i) => {
          return new Promise((resolve) => {
            setTimeout(() => {
              this.displayedSteps.push(step.slug);
              this.$emit('swiperUpdate')
              setTimeout(() => {
                this.progress[step.slug] = this.summaryItems[step.slug]?.px;
                this.EventBus.$emit("device:haptic", 'light');
              }, this.timing.steps)
              resolve();
            }, i * this.timing.steps);
          });
        });

        if (this.readMore) {
          promises.push(
            new Promise((resolve) => {
              setTimeout(() => {
                this.showReadMore = true;
                this.$emit('swiperUpdate')
                resolve();
              }, this.summarySequence?.length * this.timing.steps);
            })
          )
        }

        if (this.focus && this.isUnlocked(this.focus)) {
          promises.push(
            new Promise((resolve) => {
              setTimeout(() => {
                this.showHistory = true;
                this.$emit('swiperUpdate')
                resolve();
              }, this.summarySequence?.length * this.timing.steps);
            })
          )
        } else if (this.focus && !this.isUnlocked(this.focus)) {
          // Track is locked
          promises.push(
            new Promise((resolve) => {
              setTimeout(() => {
                this.showLocked = true;
                this.$emit('swiperUpdate')
                resolve();
              }, this.summarySequence?.length * this.timing.steps);
            })
          )
        }

        if (!this.$refs.lottie) { return; }

        Promise.all(promises).then(() => {
          setTimeout(() => {
            this.$refs.lottie?.play()
          }, this.summarySequence?.length * this.timing.steps)
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';  

  .summary {
    width: 100%;
    padding: 0;
    // padding: 0 4rem;

    .summary-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 1.2rem;
      height: 60px;
      font-size: 16px;

      .more {
        display: flex;
        align-items: center;
        color: $neutral-400;

        svg {
          margin-left: 0.5rem;

          path {
            fill: rgba($neutral-400, 0.25);
          }
        }
      }

      .icon {
        display: flex;
        align-items: center;

        svg {
          margin-right: 0.5rem;
        }
      }

      .item-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      &.locked {
        color: rgba($neutral-400, 0.3);

        .more {
          color: rgba($neutral-400, 0.3);
        }
      }
    }

    .animated-border--legacy {
      height: 1px;
      width: 100%;
      background: rgba($neutral-400, 0.3);
      opacity: 0;
      transform: translateY(10px);
      animation: fade-slide-right 0.6s ease-in-out forwards;
    }
  }

  .stat-tracker {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    animation: fade-slide-right 0.6s ease-in-out forwards;

    .message {
      font-size: 16px;
      margin-left: 1rem;
      text-align: left;
    }
  }

  .read-more {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin: 2rem auto 1rem auto;
    padding: 2rem 1.5rem;
    background: rgba($neutral-400, 0.1);
    border-radius: 10px;
    font-size: 1rem;
    line-height: 150%;
    text-align: center;

    .bold {
      font-weight: bold;
    }
  }

  .history {
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    border: 1px solid rgba($neutral-400, 0.25);
    margin-top: 1.5rem;

    .row {
      display: flex;
      align-items: center;
      padding: 1rem;
      width: 100%;

      &:not(:last-child) {
        border-bottom: 1px solid rgba($neutral-400, 0.25);
      }

      .summary-image {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 500px;
        overflow: hidden;
        margin-right: 0.5rem;

        img {
          width: 100%;
          height: 100%;
          border-radius: 500px;
          object-fit: cover;
        }

        &.placeholder {
          background: rgba($neutral-400, 0.25);
        }
      }
    }
  }

  .track-locked {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
    padding: 2rem;
    border-radius: 20px;
    font-size: 0.9rem;
    text-align: center;
    background: rgba($neutral-400, 0.1);

    h3 {
      margin: 1rem 0;
    }

    svg {
      width: 1.5rem;
      height: 1.5rem;

      path {
        fill: $neutral-100;

        .darkmode & {
          fill: $neutral-600;
        }
      }
    }
  }

  @keyframes fade-slide-right {
    from {
      opacity: 0;
      transform: translateX(50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes bounce-in {
    0% {
      transform: translateX(50px) scale(0.9);
      opacity: 0;
    }
    60% {
      transform: translateX(-5px) scale(1.05);
      opacity: 1;
    }
    100% {
      transform: translateX(0) scale(1);
    }
  }

  .fade-slide-right-enter-active {
    transition: all 0.6s ease-in-out;
  }
  .fade-slide-right-enter-from {
    transform: translateX(50px);
    opacity: 0;
  }

  .bounce-in {
    animation: bounce-in 0.6s ease-in-out both;
    animation-delay: 0.3s;
  }
</style>